"use client";

import Link from "next/link";
import React from "react";

const data = [
  { title: "Home", link: "/" },
  { title: "Games", link: "#games" },
  { title: "Stats", link: "#stats" },
  { title: "Join Us", link: "#joinus" },
  { title: "Blog", link: "#blog" },
  { title: "Contact", link: "#contact" } // better than #home
];

const Footer = () => {
  const handleScroll = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    href: string
  ) => {
    // Only handle hash links
    if (href.startsWith("#")) {
      e.preventDefault();
      const targetId = href.replace("#", "");
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <div className="w-full h-full">
      <div className="w-full h-0.5 bg-yellow-500" />
      <div className="wrapper">
        <div className="flex flex-wrap gap-6 justify-center items-center">
          {data.map((e, i) => (
            <Link
              href={e.link}
              key={i}
              aria-label={e.title}
              onClick={(ev) => handleScroll(ev, e.link)}
              className="lg:text-lg text-nowrap font-medium text-white hover:text-yellow-400 transition-colors duration-300"
            >
              {e.title}
            </Link>
          ))}
        </div>
        <p className="text-sm text-gray-500 text-center mt-6">
          © 2025 Evonix Ventures LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
